import React from 'react';
import css from './IndicatesRequired.module.css';
import { Paragraph } from '../../../text';

const IndicatesRequired: React.FC = () => {
  return (
    <div>
      <Paragraph className={css.required} small={true} text="* " />
      <Paragraph small={true} text="Indicates a required field" />
    </div>
  );
};

export default IndicatesRequired;
